import { Button, IconButton, Grid, Tooltip } from "@material-ui/core";
import { Visibility } from "@material-ui/icons";
import { useState } from "react";
import CustomRendererPopup from "./CustomRendererPopup";
import { staticValueFinder } from "../../HelperFunctions";
import { TooltipWrapper } from "../../../../../../../Common/Utils/common_utils";
const CustomRendererOpener = (props) => {
  const [isCustomPopupOpen, setIsCustomPopupOpen] = useState(false);
  const [customAnchor, setCustomAnchor] = useState(null);
  const handleClose = () => {
    setIsCustomPopupOpen(false);
    setCustomAnchor(null);
  };
  const { cell, inputValue } = props;

  const staticValue = staticValueFinder(
    "customComponent",
    {
      getValue: () => inputValue,
      getContext: () => {},
    },
    cell.column.columnDef.customComponentKey
  );
  return (
    <>
      <Grid container style={{ height: "100%" }} alignItems="center">
        <Grid item xs={9} style={{ overflow: "hidden" }}>
          <Tooltip title={`${staticValue?.length > 20 ? staticValue : ""}`}>
            <div> {staticValue} </div>
          </Tooltip>
        </Grid>
        <Grid
          item
          xs={3}
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <IconButton
            color="secondary"
            onClick={(event) => {
              setIsCustomPopupOpen(true);
              setCustomAnchor(event.target);
            }}
            variant="contained"
            style={{ width: "100%", textTransform: "none" }}
          >
            <Visibility />
          </IconButton>
        </Grid>
      </Grid>

      <CustomRendererPopup
        isCustomPopupOpen={isCustomPopupOpen}
        handleClose={handleClose}
        customAnchor={customAnchor}
        {...props}
      />
    </>
  );
};
export default CustomRendererOpener;
